import { lazy, Suspense } from 'react';
import { vis_benefit_extended, vis_compare, vis_deposite, vis_movein_price, vis_no_available_unit, vis_prepaidrent }           from 'state/store.global'
import { vis_share }             from 'state/store.global'
import { vis_calculate_benefit } from 'state/store.global'
import { useAtom }               from 'state/jotai'

// Lazy load portal components to reduce initial bundle size
const ComparePortal = lazy(() => import('components/Compare/Compare.Portal').then(m => ({ default: m.ComparePortal })));
const SharePortal = lazy(() => import('components/Share/Share.Portal').then(m => ({ default: m.SharePortal })));
const BenefitPortal = lazy(() => import('components/HousingBenefit/HousingBenefit').then(m => ({ default: m.BenefitPortal })));
const HousingBenefitExtended = lazy(() => import('components/HousingBenefit/HousingBenefitExtended').then(m => ({ default: m.HousingBenefitExtended })));
const MoveInPricePortal = lazy(() => import('components/HousingBenefit/moveInPrice').then(m => ({ default: m.MoveInPricePortal })));
const DepositePortal = lazy(() => import('components/HousingBenefit/Deposite').then(m => ({ default: m.DepositePortal })));
const PrePaidRentPricePortal = lazy(() => import('components/HousingBenefit/PrepaidRent').then(m => ({ default: m.PrePaidRentPricePortal })));
const NoAvailableUnit = lazy(() => import('components/NoAvailableUnit/NoAvailableUnit.Portal').then(m => ({ default: m.NoAvailableUnit })));

export const Portals = () => {

  const [comp, setComp]   = useAtom(vis_compare)
  const [share, setShare] = useAtom(vis_share)
  const [bene, setBene]   = useAtom(vis_calculate_benefit)
  const [beneExtended, setBeneExtended] = useAtom(vis_benefit_extended);
  const [mP, setMP]                     = useAtom(vis_movein_price);
  const [deposite, setDeposite]         = useAtom(vis_deposite);
  const [prePaidRent, setPrePaidRent]   = useAtom(vis_prepaidrent);
  const [availableUnit, setAvailableUnit]   = useAtom(vis_no_available_unit);

  return (
    <>
    { comp  && <Suspense fallback={null}><ComparePortal close={()=>setComp(false)}/></Suspense> }
    { share && <Suspense fallback={null}><SharePortal close={()=>setShare(false)}/></Suspense>  }
    { bene  && <Suspense fallback={null}><BenefitPortal close={()=>setBene(false)}/></Suspense> }
    { beneExtended && <Suspense fallback={null}><HousingBenefitExtended close={() => setBeneExtended(false)} /></Suspense> }
    { mP && <Suspense fallback={null}><MoveInPricePortal close={() => setMP(false)} /></Suspense>}
    { deposite && <Suspense fallback={null}><DepositePortal close={() => setDeposite(false)} /></Suspense>}
    { prePaidRent && <Suspense fallback={null}><PrePaidRentPricePortal close={() => setPrePaidRent(false)} /></Suspense>}
    { availableUnit && <Suspense fallback={null}><NoAvailableUnit close={()=>setAvailableUnit(false)}/></Suspense>}
    </>
  )

}
